const addSlidesToSlider = (sliderElement, { width, height } = {}) => {
    var _a, _b;
    const photosArray = JSON.parse(sliderElement.dataset.photos || '[]');
    const photosPath = (_a = sliderElement.dataset.photosPath) !== null && _a !== void 0 ? _a : '';
    const alt = (_b = sliderElement.dataset.alt) !== null && _b !== void 0 ? _b : '';
    if (!photosArray.length)
        return;
    const newSlides = photosArray.map(photoUrl => {
        const img = document.createElement('img');
        img.src = `${photosPath}${photoUrl}`;
        img.loading = 'lazy';
        img.alt = alt;
        if (width && height) {
            img.width = width;
            img.height = height;
        }
        const slide = document.createElement('swiper-slide');
        slide.append(img);
        return slide;
    });
    sliderElement.swiper.appendSlide(newSlides);
};
export default addSlidesToSlider;
